import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'mailArray',
	standalone: true,
	pure: true,
})
export class MailArrayPipe implements PipeTransform {
	transform(value: string[] | null | undefined): string {
		if (!value || value.length === 0) return '-';
		return value.join(', ');
	}
}
